import { createContext, useContext } from 'react';
import type { RecommendationProfileContextProps } from './interfaces';

export const RecommendationProfileContext =
  createContext<RecommendationProfileContextProps | null>(null);

export const useRecommendationProfile = () => {
  const context = useContext(RecommendationProfileContext);

  if (!context) {
    throw new Error(
      'useRecommendationProfile must be used within a ProfileContext'
    );
  }

  return context;
};
